import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Core } from './core';
// import { Settings } from './settings';

export const buildingGuard: CanActivateFn = async (route, state) => {
  const $core = inject(Core);
  // const $settings = inject(Settings);
  const router = inject(Router);

  // Esperamos a que el servicio intente restaurar la sesión
  await $core.ensureLoaded();

  if (!!$core.selectedBuilding()) {
    // Desactivado: bloqueaba ~1s la navegación del sidebar en cada click.
    // Si el API devolvía tenantEmail vacío, refetch de basic-data en cada ruta.
    // Solo lo usa de forma relevante "Enviar consulta" (ya lo pide en su ngOnInit).
    // Revisar con el equipo si hace falta restaurarlo aquí.
    // if (!$settings.tenant()?.tenantEmail) {
    //   await $settings.fetchTenantMe($core.selectedBuilding()!.tenantId);
    // }
    return true; // Puede pasar
  } else {
    // Si no hay edificio y no estamos ya en la pantalla de selección, redirigimos
    return router.parseUrl('/buildings');
  }
};
